import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';
export const PremiumEnterpriseAdminsChangeBoarding = withAsync({
    loader: lazyForPaint(
        () =>
            import(
                /* webpackChunkName: "premium-enterprise-admins-changeboarding" */ './premium-enterprise-admins-changeboarding'
            )
    ),
    LoadingSkeleton: () => null,
});
